<template>
  <div class="result-container">
    <img
      src="../assets/logo.png"
      class="logo-result"
      alt="ICMSS 2021"
      @click="goToSplash"
    >

    <div class="text-wrapper-container">
      <div
        v-if="!invalid"
        class="text-wrapper"
      >
        <h2 class="name-title">
          <b>{{ name }},</b>
        </h2>
        <h2 class="subtitle is-size-4-mobile is-marginless">
          based on your answers,
        </h2>
        <h2 class="subtitle is-size-4-mobile is-marginless">
          <b>these are your shades of blue!</b>
        </h2>
      </div>
      <div
        v-else
        class="text-wrapper-invalid"
      >
        <div class="invalid-text-content">
          <h2 class="subtitle is-size-3-mobile is-marginless">
            <b>It's still too tricky to find your shade of blue,</b>
          </h2>
          <h2 class="subtitle is-size-3-mobile is-marginless">
            Please try this quiz again and vary your answers.
          </h2>
        </div>
        <img
          src="@/assets/jempolan.png"
          class="jempolan-invalid"
          alt="Jempolan"
        >
      </div>
    </div>
    <div
      v-if="suggestions.length > 0"
      class="carousel-container"
    >
      <div 
        class="carousel-wrapper"
        :class="{ 'column-layout': isColumnLayout }"
      >
        <div
          v-for="(suggestion, index) in suggestions"
          :key="index"
          class="carousel-card"
          :class="{ 
            'active-card': index === activeCardIndex,
            'side-card': index !== activeCardIndex,
            'flipped': flippedCards[index] 
          }"
        >
          <div
            class="card-flip"
            @click="selectCard(index, suggestion)"
          >
            <div class="card-flip-inner">
              <div
                class="card-front"
                :style="{ backgroundImage: 'url(' + getCardImage(index) + ')' }"
              >
                <div class="card-content">
                  <h2 class="card-title">
                    <b>{{ suggestion }}</b>
                  </h2>
                  <p class="tap-to-read">
                    Tap to read more.
                  </p>
                </div>
              </div>
              <div
                class="card-back"
                :style="{ backgroundImage: 'url(' + require('@/assets/bg-DetailCard.png') + ')' }"
              >
                <div class="card-back-content">
                  <result-strip :result="suggestion" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="suggestions.length > 0 && quizData.user.major !== 'Management'"
      class="callout-text-above-registration"
      style="color: #D5B13D; text-align: center; font-size: 1.2rem; margin-bottom: 10px;"
    >
      *However, If you are a <b>non-Management student</b>, the division available for you to apply is <b>Delegate Relations</b> division.
    </div>
    <div
      v-if="suggestions.length > 0"
      class="registration-box"
    >
      <div class="registration-content">
        <div class="registration-text-wrapper">
          <p class="registration-title">
            Ready to join the blue family?
          </p>
          <p class="registration-subtitle">
            Register <strong><a
              href="https://linktr.ee/icmssfebui"
              target="_blank"
            >here</a></strong> now as The 25th ICMSS associates!
          </p>
        </div>
        <img
          src="@/assets/jempolan.png"
          class="jempolan-image"
          alt="Jempolan"
        >
      </div>
    </div>
  </div>
</template>

<script>
import ResultStrip from "./ResultStrip.vue";
import data from "../results.json";
import api from '../services/api';

export default {
  name: "Result",
  components: {
    ResultStrip,
  },
  props: {
    quizData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      suggestions: [],
      selected: null,
      invalid: false,
      flippedCards: {},
      activeCardIndex: null,
      isColumnLayout: false,
    };
  },
  computed: {
    name() {
      return this.quizData.user.name;
    },
    noPadding() {
      return !this.selected ? "is-paddingless" : null;
    },
    anyCardFlipped() {
      return Object.values(this.flippedCards).some(isFlipped => isFlipped);
    }
  },
  async mounted() {
    // Check screen size and set layout
    this.checkLayout();
    window.addEventListener('resize', this.checkLayout);
    
    const total = Object.keys(this.quizData.answers).reduce(
      (accum, key) => (accum += this.quizData.answers[key]),
      0
    );
    if (total == 0 || total == Object.keys(this.quizData.answers).length * 5) {
      this.invalid = true;
      return;
    }
    try {
      const answers = [];
      for (var i in this.quizData.answers)
        answers.push([i, this.quizData.answers[i]]);
      const sortedAnswers = answers.sort((a, b) => {
        if (b[1] === a[1]) {
          Math.random() < 0.5 ? 1 : -1;
        } else {
          return b[1] - a[1];
        }
      });
      console.log(sortedAnswers);
      const allResults = data.suggestions;
      const finalResults = [];
      finalResults.push(allResults[sortedAnswers[0][0]]);
      finalResults.push(allResults[sortedAnswers[1][0]]);
      finalResults.push(allResults[sortedAnswers[2][0]]);
      console.log("FinalResults");
      console.log(finalResults);
      this.suggestions = finalResults;
      try {
        const payload = {
          user: this.quizData.user,
          answers: this.quizData.answers,
          suggestions: this.suggestions,
        };
        await api.postSubmission(payload);
        console.log('Submission saved successfully!');
      } catch (error) {
        console.error('Failed to save submission:', error);
      }
    } catch (error) {
      console.error(error);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkLayout);
  },
  methods: {
    checkLayout() {
      // Use column layout for screens smaller than 1800px
      this.isColumnLayout = window.innerWidth < 1800;
    },
    getCardImage(index) {
      return require('@/assets/bg-card.png');
    },
    selectCard(index, suggestion) {
      if (index === this.activeCardIndex && this.flippedCards[index]) {
        this.$set(this.flippedCards, index, false);
        this.selected = null;
        this.activeCardIndex = null; // Set to null so no card is active (all same size)
      } else {
        // Reset all flipped cards and set new active card
        this.flippedCards = {};
        this.activeCardIndex = index;
        this.$set(this.flippedCards, index, true);
        this.selected = suggestion;
      }
    },
    selectedClass(key) {
      return this.selected === key ? "selected" : null;
    },
    goToSplash() {
      // Navigate back to splash screen (step 0)
      this.$emit("go-to-splash");
    },
  }
};
</script>

<style scoped>
.result-container {
  min-height: 90vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.stretch {
  margin: 0 !important;
  padding: 0 !important;
}

.column {
  padding: 15px;
}

.register-text {
  font-family: 'Montserrat', sans-serif;
  font-size: 25px;
  color: #D99E30;
  text-align: center;
  margin-top: 25px;
}

.register-text a {
  font-family: 'Montserrat', sans-serif;
  color: inherit;
  text-decoration: none;
  font-weight: bold;
}

.result-wrapper {
  margin-top: 15px;
  display: flex;
  justify-content: center;
  width: 100%;
}

.card-flip {
  width: 550px;
  height: 400px;
  perspective: 1000px;
  cursor: pointer;
  position: relative;
  margin: 10px;
  flex-shrink: 0;
}

.card-flip-inner {
  width: 100%;
  height: 100%;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  position: absolute;
}

.flipped .card-flip-inner {
  transform: rotateY(180deg);
}

.card-front,
.card-back {
  width: 100%;
  height: 100%;
  position: absolute;
  backface-visibility: hidden;
  border-radius: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
}

.card-front {
  z-index: 2;
  transform: rotateY(0deg);
}

.card-back {
  transform: rotateY(180deg);
  color: white;
  padding: 30px;
  box-sizing: border-box;
  justify-content: center;
  background-size: cover;
  background-position: center;
}

.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
}

.card-back-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  font-size: 0.4rem;
}

.card-title {
  color: #FFFFFF !important;
  text-transform: capitalize;
  margin: 20px 0;
  position: relative;
  z-index: 3;
  font-size: 2.5rem;
  text-align: center;
  font-family: 'Montserrat', sans-serif;
}

.tap-to-read {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.5rem;
  text-align: center;
  margin: 10px 0 20px 0;
  font-family: 'Montserrat', sans-serif;
}

.registration-box {
  position: relative;
  background: white;
  border-radius: 25px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  margin: 20px auto; /* Reduced margin */
  width: 100%;
  padding: 40px;
  text-align: center;
  overflow: hidden;
  flex: 0 0 auto;
}

.registration-content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.registration-text-wrapper {
  flex: 1;
}

.registration-title {
  color: #00125F;
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 15px;
  font-family: 'Montserrat', sans-serif;
}

.registration-subtitle {
  color: #00125F;
  font-size: 1.2rem;
  margin: 0;
  font-family: 'Montserrat', sans-serif;
}

.registration-subtitle a {
  color: #00125F;
  text-decoration: underline;
}

.jempolan-image {
  width: 120px;
  height: auto;
  flex-shrink: 0;
}

.text-wrapper-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  margin: 20px 0;
}

.text-wrapper-container:has(.text-wrapper-invalid) {
  flex: 1;
  align-items: center;
  justify-content: center;
  min-height: 70vh;
}

.text-wrapper {
  text-align: center;
  z-index: 2;
}

.text-wrapper-invalid {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  z-index: 2;
}

.invalid-text-content {
  text-align: left;
  flex: 1;
}

.jempolan-invalid {
  width: 120px;
  height: auto;
  flex-shrink: 0;
}

.name-title {
  font-size: 3rem !important;
  font-weight: bold !important;
  color: #D5B13D;
  margin-bottom: 0 !important;
  font-family: 'Montserrat', sans-serif;
}

.carousel-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 20px 0;
  min-height: 0;
}

.carousel-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  perspective: 1000px;
  width: 100%;
}

.carousel-card {
  transition: all 0.5s ease;
  cursor: pointer;
  flex: 0 0 auto;
  position: relative;
}

/* Default state - all cards same size */
.carousel-card:not(.active-card) {
  transform: scale(1);
  opacity: 1;
  z-index: 1;
}

/* Side cards - ensure they are centered */
.side-card {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Active card - slightly larger and in front */
.active-card {
  transform: scale(1.05);
  z-index: 3;
}

/* When a card is active, make other cards smaller and move away */
.carousel-wrapper:has(.active-card) .carousel-card:not(.active-card) {
  transform: scale(0.8);
  opacity: 0.7;
  z-index: 1;
}

/* Row layout - push side cards horizontally */
.carousel-wrapper:not(.column-layout):has(.active-card) .carousel-card:first-child:not(.active-card) {
  transform: scale(0.8) translateX(-30px);
}

.carousel-wrapper:not(.column-layout):has(.active-card) .carousel-card:last-child:not(.active-card) {
  transform: scale(0.8) translateX(30px);
}

/* Column layout - push side cards vertically */
.carousel-wrapper.column-layout:has(.active-card) .carousel-card:first-child:not(.active-card) {
  transform: scale(0.8) translateY(-20px);
}

.carousel-wrapper.column-layout:has(.active-card) .carousel-card:last-child:not(.active-card) {
  transform: scale(0.8) translateY(20px);
}

/* Large screens - use row layout when there's enough space */
@media screen and (min-width: 1400px) {
  .carousel-wrapper {
    flex-direction: row;
    gap: 30px;
  }

  .card-flip {
    height: 360px;
    max-width: 420px;
  }
}

/* Medium to large screens - use column layout */
@media screen and (max-width: 1399px) {
  .carousel-wrapper {
    flex-direction: column;
    gap: 25px;
  }
  
  .carousel-wrapper.column-layout .carousel-card {
    width: 100%;
    max-width: 550px;
  }
}

@media screen and (max-width: 1024px) and (min-width: 769px) {
  .carousel-wrapper {
    flex-direction: column;
    gap: 20px;
    justify-content: center;
    align-items: center;
  }
  
  .carousel-card {
    width: 100%;
    max-width: 450px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .card-flip {
    height: 360px;
    max-width: 450px;
  }
  
  .registration-content {
    gap: 15px;
  }
  
  .jempolan-image {
    width: 100px;
  }
}

/* Fixed mobile layout to maintain desktop card appearance while keeping vertical layout */
@media screen and (max-width: 768px) {
  .result-container {
    padding: 20px 0;
  }
  
  .name-title {
    font-size: 2.5rem !important;
  }
  
  .carousel-container {
    padding: 20px;
    margin: 30px 0;
  }
  
  .carousel-wrapper {
    flex-direction: column;
    gap: 25px;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  
  /* Keep desktop card dimensions and styling */
  .card-flip {
    height: 440px;
    max-width: 320px;
    width: 100%;
    margin: 0 auto;
  }
  
  .carousel-card {
    max-width: 320px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
  
  /* Ensure side-cards are also centered on mobile */
  .side-card {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  /* Maintain desktop-like scaling effects for mobile */
  .carousel-card:not(.active-card) {
    transform: scale(1);
    opacity: 1;
  }
  
  .active-card {
    transform: scale(1.05);
  }
  
  .carousel-wrapper:has(.active-card) .carousel-card:not(.active-card) {
    transform: scale(0.85);
    opacity: 0.8;
  }
  
  .carousel-wrapper:has(.active-card) .carousel-card:first-child:not(.active-card) {
    transform: scale(0.85) translateY(-15px);
  }

  .carousel-wrapper:has(.active-card) .carousel-card:last-child:not(.active-card) {
    transform: scale(0.85) translateY(15px);
  }
  
  /* Keep desktop font sizes */
  .card-title {
    font-size: 2.5rem;
  }
  
  .tap-to-read {
    font-size: 1.5rem;
  }
  
  .text-wrapper-invalid {
    flex-direction: column;
    text-align: center;
    padding: 0 20px;
  }
  
  .invalid-text-content {
    text-align: center;
  }
  
  .jempolan-invalid {
    width: 100px;
  }
  
  .registration-box {
    margin: 20px auto; /* Reduced margin for mobile */
    padding: 30px 20px;
    max-width: calc(100% - 40px); /* Added responsive max-width with padding consideration */
  }
  
  .registration-content {
    flex-direction: column;
    text-align: center;
  }
  
  .jempolan-image {
    width: 100px;
    order: -1;
    margin-bottom: 20px;
  }
  
  .registration-title {
    font-size: 1.5rem;
  }
  
  .registration-subtitle {
    font-size: 1rem;
  }
}

/* Adjusted very small screens to maintain card quality */
@media screen and (max-width: 480px) {
  .carousel-container {
    padding: 15px;
    margin: 25px 0;
  }
  
  .card-flip {
    height: 380px;
    max-width: 280px;
    margin: 0 auto;
  }
  
  .carousel-card {
    max-width: 280px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
  
  /* Ensure side-cards are also centered on very small screens */
  .side-card {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .carousel-wrapper {
    flex-direction: column;
    gap: 20px;
    align-items: center;
    justify-content: center;
  }
  
  .card-title {
    font-size: 2rem;
  }
  
  .tap-to-read {
    font-size: 1.2rem;
  }
  
  .text-wrapper-invalid {
    padding: 0 15px;
  }
  
  .jempolan-invalid {
    width: 80px;
  }
}
</style>

<style scoped>
.logo-result {
  position: absolute;
  top: 35px;
  right: 5%;
  width: auto;
  max-height: 10vh;
  z-index: 100;
  cursor: pointer;
}

@media screen and (max-width: 991px) {
  .logo-result {
    top: 20px;
    right: 20px;
    max-height: 8vh;
  }
}

@media screen and (max-width: 768px) {
  .logo-result {
    top: 15px;
    right: 15px;
    max-height: 7vh;
  }
}

@media screen and (max-width: 480px) {
  .logo-result {
    top: 10px;
    right: 10px;
    max-height: 6vh;
  }
}
</style>
